import React, { FC } from 'react';
import styled from 'styled-components';
import { RichBanner } from '../../../types/banner';

const BannerBlade = styled.div`
  position: relative;
  height: 250px;
  margin-bottom: 20px;
`;

const Container = styled.div`
  position: absolute;
  display: flex;
  height: 100%;
  justify-content: space-between;
  flex-direction: column;
  padding: 10px;
`;

const BannerContainer = styled.div`
  padding: 0 20px;
  display: flex;
  align-items: center;
  flex-grow: 1;
  border: 2px solid #b56b6e;
  border-radius: 10px;
  padding: 10px;
  background-color: #f7d8d8;
`;

const WarningBannerText = styled.div`
  color: #460002;
  text-align: left;

  a {
    text-decoration: underline;
  }
`;

interface WarningBannerProps {
  banner: RichBanner;
}

export const WarningBanner: FC<WarningBannerProps> = ({ banner }) => {
  return (
    <BannerBlade>
      <Container>
        <BannerContainer>
          <WarningBannerText><p dangerouslySetInnerHTML={{__html: banner.content}}></p></WarningBannerText>
        </BannerContainer>
      </Container>
    </BannerBlade>
  )
};